export default function InlineSteps({
  currentStep,
  doneStep1,
  doneStep2,
  doneStep3,
  onGoDetails,
  onGoVerify,
  onGoSign,
  canGoVerify,
  canGoSign,
}: {
  currentStep: number;
  doneStep1: boolean;
  doneStep2: boolean;
  doneStep3: boolean;
  onGoDetails: () => void;
  onGoVerify: () => void;
  onGoSign: () => void;
  canGoVerify: boolean;
  canGoSign: boolean;
}) {
  const basePill =
    "flex items-center gap-1.5 px-2 py-1 rounded-full border text-xs transition-colors";
  const badge = (active: boolean, completed: boolean) =>
    `flex items-center justify-center h-4 w-4 rounded-full ${
      completed
        ? "bg-terracotta-600 text-white"
        : active
        ? "bg-terracotta-500 text-white"
        : "bg-terracotta-100 text-terracotta-700"
    }`;
  const pill = (active: boolean) =>
    `${basePill} ${
      active
        ? "border-terracotta-500 bg-terracotta-50"
        : "border-terracotta-200 bg-white"
    }`;

  return (
    <div className="flex w-full items-center justify-around gap-1">
      <button
        type="button"
        onClick={onGoDetails}
        className={`${pill(currentStep === 1)} cursor-pointer`}
        aria-current={currentStep === 1 ? "step" : undefined}
      >
        <span className={badge(currentStep === 1, doneStep1)}>1</span>
        <span className="text-brown-800">Details</span>
      </button>
      <button
        type="button"
        onClick={canGoVerify ? onGoVerify : undefined}
        disabled={!canGoVerify}
        className={`${pill(currentStep === 2)} ${
          canGoVerify ? "cursor-pointer" : "opacity-60 cursor-not-allowed"
        }`}
        aria-current={currentStep === 2 ? "step" : undefined}
      >
        <span className={badge(currentStep === 2, doneStep2)}>2</span>
        <span className="text-brown-800">Verify</span>
      </button>
      <button
        type="button"
        onClick={canGoSign ? onGoSign : undefined}
        disabled={!canGoSign}
        className={`${pill(currentStep === 3)} ${
          canGoSign ? "cursor-pointer" : "opacity-60 cursor-not-allowed"
        }`}
        aria-current={currentStep === 3 ? "step" : undefined}
      >
        <span className={badge(currentStep === 3, doneStep3)}>3</span>
        <span className="text-brown-800">Sign</span>
      </button>
    </div>
  );
}
